export const ADD_TODO = 'ADD_TODO'
export const UPDATE_TODO = 'UPDATE_TODO'
export const FILTER_TODO = 'FILTER_TODO'
export const REMOVE_TODO = 'REMOVE_TODO'
export const SHOW_STATE = 'SHOW_STATE'
